/**
 * Deep link from Staff Profiles into one person's training compliance (TRUS-548).
 *
 * The ticket asked to "view and edit staff records, assign trainings, view status of
 * trainings". Records and compliance already live on the Training hub, so the roster
 * links across rather than growing a second copy of them.
 *
 * Both surfaces are activeTab pages inside the app shell, not react-router routes, so
 * navigation is the shell's own trio: set `activeTab`, leave a one-shot key for the
 * hub's internal tab, and fire `changeTab`. `navigateToHubTab` in ./hubs/hubNavigation
 * does the same thing from the immersive react-router pages, which have a navigate().
 */

export const FOCUS_STAFF_KEY = 'training_focus_user_id'

const TRAINING_HUB_TAB = 'workforce-training-hub'

/** Open the Training hub's Compliance tab, filtered to one staff member. */
export function openStaffTrainingCompliance(userId: number): void {
  try {
    localStorage.setItem(FOCUS_STAFF_KEY, String(userId))
    localStorage.setItem('activeTab', TRAINING_HUB_TAB)
    localStorage.setItem(`hub_subtab:${TRAINING_HUB_TAB}`, 'compliance')
  } catch {
    // Private mode. The tab change below still works; it just lands unfiltered.
  }
  window.dispatchEvent(new CustomEvent('changeTab', { detail: TRAINING_HUB_TAB }))
}
